export enum BOOKING_REVIEW_STATUS {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
}

export type BookingReviewStatus =
  (typeof BOOKING_REVIEW_STATUS)[keyof typeof BOOKING_REVIEW_STATUS];
